<template>
  <div class="pay-info-container">
    <el-card>
      <template #header>
        <TitleItem title="支付信息" />
      </template>
      <el-form ref="payInfoForm" :model="payInfoModel" label-width="125px">
        <el-form-item v-if="isSetWxFee == 1" label="微信支付">
          <el-checkbox v-model="payInfoModel.isAssumeWxFee" :true-label="1" :false-label="0">启用</el-checkbox>
          <!--<template v-if="isWxReal == 1">
            <span class="weChatTipsNormal">(商家需承担0.6%的手续费)</span>
          </template>
          <template v-else>
            <span class="weChatTipsNormal">(商家需承担0.63%的手续费)</span>
            <span class="weChatUpdateTips">微信支付升级后享受活动期间0.6%的手续费</span>
            <el-button class="weChatUpdateBtn" type="text" @click="weChatUpdateClick">立即升级</el-button>
          </template>-->
          <template>
            <span class="weChatTipsNormal">(商家需承担0.63%的手续费)</span>
          </template>
        </el-form-item>
        <el-form-item v-if="is_alipay == 1" label="支付宝支付">
          <el-checkbox v-model="payInfoModel.isAssumeAlipayFee" :true-label="1" :false-label="0">启用</el-checkbox>
          <span class="weChatTipsNormal">(商家需承担0.6%的手续费(活动期费率))</span>
        </el-form-item>
        <el-form-item v-if="is_fast_payment == 1" label="银行卡支付">
          <el-checkbox v-model="payInfoModel.isAssumeCloudFee" :true-label="1" :false-label="0">启用</el-checkbox>
          <span class="weChatTipsNormal">(商家需承担手续费：储蓄卡:0.3%,信用卡:0.6%)</span>
        </el-form-item>
        <el-form-item v-if="is_multiply_pay == 1" label="多次支付">
          <el-checkbox v-model="payInfoModel.isMultiplyPay" :true-label="1" :false-label="0">启用</el-checkbox>
        </el-form-item>
        <el-form-item v-if="is_receipt_confirmation == 1" label="收货确认">
          <el-checkbox v-model="payInfoModel.isReceiptConfirmation" :true-label="1" :false-label="0">启用</el-checkbox>
          <span class="weChatTipsNormal">(启用后，卖家可以确认订单最终收货数量)</span>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import TitleItem from "./TitleItem.vue";

const { mapState } = createNamespacedHelpers("publishGoods/publishGoods");
export default {
  components: {
    TitleItem,
  },
  data() {
    return {
      isSetWxFee: 1, //= 1 时，才展示 微信支付 这一行 配置；
      is_alipay: 1, // = 1 时，展示 支付宝支付这一行 配置；
      is_fast_payment: 1, //= 1 时，展示 银行卡支付这一行配置
      is_multiply_pay: 1, //= 1时，展示启动多次支付这一行配置
      is_receipt_confirmation: 1, //= 1时，展示启用收货确认这一行配置
      isWxReal: 0, // 是否微信支付认证， 1: (需承担0.6%的手续费)  0:(需承担0.63%的手续费)
      payInfoModel: {
        isAssumeWxFee: 0, // 是否启用微信支付 0:否，1:是
        isAssumeAlipayFee: 0, // 是否启用支付宝支付 0:否，1:是
        isAssumeCloudFee: 0, // 是否启用银行卡支付 0:否，1:是
        isMultiplyPay: 0, // 是否启用多次支付，0:否，1:是
        isReceiptConfirmation: 0, // 是否启用收货确认，0:否，1:是
      },
    };
  },
  computed: {
    ...mapState(["goodsDetail", "shopConfig"]),
  },
  watch: {
    goodsDetail(newVal) {
      this.payInfoModel.isAssumeWxFee = newVal.firstSku.isAssumeWxFee;
      this.payInfoModel.isAssumeAlipayFee = newVal.firstSku.isAssumeAlipayFee;
      this.payInfoModel.isAssumeCloudFee = newVal.firstSku.isAssumeCloudFee;
      this.payInfoModel.isMultiplyPay = newVal.firstSku.isMultiplyPay;
      this.payInfoModel.isReceiptConfirmation = newVal.firstSku.isReceiptConfirmation;
    },
    shopConfig(newVal) {
      this.isSetWxFee = newVal.shopDtlEntity.isSetWxFee;
      this.is_alipay = newVal.funcSettingMap.is_alipay;
      this.is_fast_payment = newVal.funcSettingMap.is_fast_payment;
      this.is_multiply_pay = newVal.funcSettingMap.is_multiply_pay;
      this.is_receipt_confirmation = newVal.funcSettingMap.is_receipt_confirmation;
      this.isWxReal = newVal.isWxReal;
    },
  },
  methods: {
    weChatUpdateClick() {
      window.open(this.shopConfig.openPayEnd, "_blank");
    },
    subMitCheck() {
      return this.payInfoModel;
    },
  },
};
</script>

<style lang="scss" scoped>
.pay-info-container {
  padding-top: 20px;
  .weChatTipsNormal {
    margin-left: 10px;
    font-size: 12px;
    color: grey;
  }
  .weChatUpdateTips {
    margin-left: 10px;
    font-size: 12px;
    color: #1890ff;
  }
  .weChatUpdateBtn {
    margin-left: 20px;
    color: #409eff;
  }
}
</style>
